import { isOrderAddendumType } from '@mummssoftware/global-context/PNCounter';

export const isOrderVoided = (
  order?: {
    voidpersonfirstname?: string | null;
  } | null,
) => !!order?.voidpersonfirstname;

export const getPhysician = (data: any) =>
  data.physicianlastname
    ? `${data.physicianfirstname} ${data.physicianlastname}${
        (data.physiciancredentials && `, ${data.physiciancredentials}`) || ''
      }`
    : '';

export const getPerson = (data: any) =>
  data.personname
    ? `${data.personname}${(data.credentials && `, ${data.credentials}`) || ''}`
    : '';

/** Widget filter: order-row snapshot + guards for PN addendum mode. */
export const buildOrderAppendWidgetFilter = (
  order: mumms.Order,
): mumms.WidgetFilter => ({
  appendToOrder: true,
  patientNumber: String(order.patientnumber),
  progressNoteId: String(order.id),
  ordertypeshortname: order.ordertypeshortname,
  isorder: order.isorder,
  ordertypename: order.ordertypename,
  orderNoteText: order.note ?? '',
  orderSigned: !!order.signaturedatetime,
  ordernotecount: order.ordernotecount ?? 0,
});

const parseEntityDto = (dto: unknown) => {
  if (!dto) {
    return null;
  }
  if (typeof dto === 'string') {
    try {
      return JSON.parse(dto);
    } catch {
      return null;
    }
  }
  return dto;
};

/**
 * Resolve entity tag fields for an order row (allowlist / append guards).
 * Uses patientprogressnoteentitydto.entitykey (not patientprogressnoteid).
 */
export const getOrderNoteEntity = (order: mumms.Order) => {
  const entityType = order?.ordertypeshortname;
  if (!isOrderAddendumType(entityType)) {
    return null;
  }

  const dto = parseEntityDto(order.patientprogressnoteentitydto);
  if (!dto) {
    return null;
  }

  const entities = Array.isArray(dto)
    ? dto
    : (dto as mumms.entityByType)[entityType as mumms.Entitytypeshortname] ||
      [];

  if (!Array.isArray(entities) || !entities.length) {
    return null;
  }

  const match =
    entities.find(
      (entity: mumms.Patientprogressnoteentitydto) =>
        entity.entitytypeshortname === entityType,
    ) || entities[0];

  if (!match?.entitykey) {
    return null;
  }

  return {
    entityKey: String(match.entitykey),
    entityType: entityType as mumms.Entitytypeshortname,
    entityName:
      match.entityname ||
      order.ordertypename ||
      match.entitytypename ||
      entityType,
  };
};
